'use client';

import dynamic from 'next/dynamic';

const HelpSearch = dynamic(() => import('./help-search'), {
  ssr: false,
});

export default function HelpClientSearch() {
  return <HelpSearch></HelpSearch>;
}
